@let page =
  pagesEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();

@if (page) {
  <div class="atn-mosaic-dev-page-general-tab">
    <div class="atn-mosaic-dev-page-general-tab__content">
      <atn-ds-text
        label="Name"
        placeholder="Enter a name"
        [value]="page.name"
        (change)="updatePage('name', $event ?? '')"
      ></atn-ds-text>
      <atn-ds-text
        label="Description"
        placeholder="Enter a description"
        [value]="page.description"
        (change)="updatePage('description', $event)"
      ></atn-ds-text>
      <atn-ds-code
        class="atn-mosaic-dev-page-general-tab__query-editor"
        label="Query"
        [json]="page.query"
        (jsonChange)="updatePageQuery($event)"
      />
    </div>
    <div class="atn-mosaic-dev-page-general-tab__content">
      <atn-ds-code
        class="atn-mosaic-dev-page-general-tab__content-editor"
        label="Content"
        [json]="page.content"
        (jsonChange)="updatePageContent($event)"
      />
    </div>
  </div>
}
